// src/config.js
const config = {
    dev: {
        apiUrl: 'http://localhost/asisa'
    },
    prod: {
        apiUrl: 'https://expathealthinsurance.es/php'
    }
}

const environment = process.env.NODE_ENV === 'production' ? 'prod' : 'dev'
export const API_URL = config[environment].apiUrl